import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { transformUpdate } from "~/Configurators/Linear/linearDataTransformer";
import { getMainKmat } from "~/Configurators/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "~/Configurators/Carriage/carriageConfiguratorConstants";
import { isNonNull } from "~/utils/reducers";

export async function sendCarriageStepChange(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";

  const response = await sendCarriage(data);

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transformUpdate(response, ConfiguratorType.Carriage, csticsToPreserve);
}

export const sendCarriageMiscChange = sendCarriageStepChange;
